import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { signupSummaryCardStyles } from './SignupSummaryCard.styles';

interface SignupSummaryCardProps {
  label: string;
  value: string;
  detail?: string;
  isWorking?: boolean;
  onChange: () => void;
}

export function SignupSummaryCard({label, value, detail = '', isWorking = false, onChange}: SignupSummaryCardProps) {
  const theme = useTheme();

  return (
    <Box sx={signupSummaryCardStyles.summaryCard(theme)}>
      <Box>
        <Typography sx={signupSummaryCardStyles.summaryLabel(theme)}>{label}</Typography>
        <Typography sx={signupSummaryCardStyles.summaryValue()}>{value}</Typography>
        {detail && <Typography sx={signupSummaryCardStyles.summaryDetail(theme)}>{detail}</Typography>}
      </Box>
      <Button type="button" variant="text" disabled={isWorking} aria-busy={isWorking} aria-label={`Change ${label}`} onClick={onChange} sx={signupSummaryCardStyles.summaryChange(theme)}>Change</Button>
    </Box>
  );
}
